import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";

const routes = [
  {
    path: "/signIn",
    name: "SignIn",
    component: () => import("../views/auth/SignInView.vue"),
  },
  // {
  //   path: "/",
  //   name: "Home",
  //   component: () =>
  //     import(/* webpackChunkName: "MenuView" */ "../views/menu/MenuView.vue"),
  //   meta: { requiresAuth: true, role: ["admin", "super_user"] },
  // },
  {
    path: "/",
    redirect: () => {
      const user = store.state.auth.user;

      if (!user) return "/signIn";

      switch (user.type) {
        case "super_user":
          return "/dashboard";
        case "admin":
          return "/dashboard";
        case "outlet_user":
          return "/pos";
        default:
          return "/signIn";
      }
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../views/dashboard/DashboardView.vue"),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
  },
  {
    path: "/pos/:orderId?",
    name: "POS",
    component: () => import("../views/pos/POSView.vue"),
    meta: { requiresAuth: true, role: ["outlet_user"] },
    props: true,
  },
  {
    path: "/orders",
    name: "Orders",
    component: () => import("../views/order/AllOrdersView.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
  },
  {
    path: "/orders/edit/:orderId",
    name: "EditOrder",
    component: () => import("../views/order/AllOrdersView.vue"),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
  },
  {
    path: "/orders/:orderId",
    name: "Order",
    component: () => import("../views/order/OrderView.vue"),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
  },
  {
    path: "/orders/receipt/:orderId",
    name: "POSThermalReceiptView",
    component: () => import("../views/order/ThermalReceiptView"),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
    props: true,
  },
  {
    path: "/orders/onHold",
    name: "OnHoldOrders",
    component: () => import("../views/order/OnHoldOrdersView.vue"),
    meta: { requiresAuth: true, role: ["outlet_user"] },
  },
  {
    path: "/orders/previous",
    name: "PreviousOrders",
    component: () => import("../views/order/PreviousOrdersView.vue"),
    meta: { requiresAuth: true, role: ["outlet_user"] },
  },
  {
    path: "/products",
    name: "Products",
    component: () => import("../views/products/AllProductsView.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
  },
  {
    path: "/products/new",
    name: "NewProduct",
    component: () => import("../views/products/NewProductView.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
  },
  {
    path: "/products/edit/:productId",
    name: "EditProduct",
    component: () => import("../views/products/EditProductView.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
    props: true,
  },
  {
    path: "/products/:productId",
    name: "Product",
    component: () => import("../views/products/ProductView.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
    props: true,
  },
  {
    path: "/products/manufacturers",
    name: "ProductManufacturers",
    component: () =>
      import("../views/products/manufacturers/AllManufacturersView.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
  },
  {
    path: "/products/manufacturers/new",
    name: "NewProductManufacturer",
    component: () =>
      import("../views/products/manufacturers/NewManufacturer.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
  },
  {
    path: "/products/manufacturers/edit/:manufacturerId",
    name: "EditProductManufacturer",
    component: () =>
      import("../views/products/manufacturers/EditManufacturerView.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
    props: true,
  },
  {
    path: "/products/manufacturers/:manufacturerId",
    name: "ProductManufacturer",
    component: () =>
      import("../views/products/manufacturers/ManufacturerView.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
    props: true,
  },
  {
    path: "/products/categories",
    name: "ProductCategories",
    component: () =>
      import("../views/products/categories/AllCategoriesView.vue"),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
  },
  {
    path: "/products/categories/new",
    name: "NewProductCategory",
    component: () => import("../views/products/categories/NewCategory.vue"),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
  },
  {
    path: "/products/categories/edit/:categoryId",
    name: "EditProductCategory",
    component: () =>
      import("../views/products/categories/EditCategoryView.vue"),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
    props: true,
  },
  {
    path: "/products/categories/:categoryId",
    name: "ProductCategory",
    component: () => import("../views/products/categories/CategoryView.vue"),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
    props: true,
  },
  {
    path: "/products/attributes",
    name: "ProductAttributes",
    component: () =>
      import("../views/products/attributes/AllAttributesView.vue"),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
  },
  {
    path: "/products/attributes/new",
    name: "NewProductAttribute",
    component: () => import("../views/products/attributes/NewAttribute.vue"),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
  },
  {
    path: "/products/attributes/edit/:attributeId",
    name: "EditProductAttribute",
    component: () =>
      import("../views/products/attributes/EditAttributeView.vue"),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
    props: true,
  },
  {
    path: "/products/attributes/:attributeId",
    name: "ProductAttribute",
    component: () => import("../views/products/attributes/AttributeView.vue"),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
    props: true,
  },
  {
    path: "/printBarcodes",
    name: "Print Product Barcodes",
    component: () => import("../views/products/PrintBarcodesView.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
    props: true,
  },
  {
    path: "/users",
    name: "Users",
    component: () => import("../views/users/AllUsersView.vue"),
    // meta: { requiresAuth: true, role: ["admin", "super_user"] },
  },
  {
    path: "/users/new",
    name: "NewUser",
    component: () => import("../views/users/NewUserView.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
  },
  {
    path: "/users/edit/:userId",
    name: "EditUser",
    component: () => import("../views/users/EditUserView.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
    props: true,
  },
  {
    path: "/users/:userId",
    name: "User",
    component: () => import("../views/users/UserView.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
    props: true,
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("../views/users/AllUsersView.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
  },
  {
    path: "/saleReports",
    name: "SaleReports",
    component: () => import("../views/reports/ReportsView.vue"),
    meta: { requiresAuth: true, role: ["outlet_user", "super_user"] },
  },
  {
    path: "/reports",
    name: "Reports",
    component: () => import("../views/reports/ReportsView.vue"),
    meta: { requiresAuth: true, role: ["admin", "outlet_user", "super_user"] },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters["auth/isAuthenticated"];

  if (!isAuthenticated) {
    try {
      await store.dispatch("auth/tokenSignIn");
    } catch (error) {
      localStorage.removeItem("session_token");
      store.commit("auth/CLEAR_AUTH");
      return next("/signIn");
    }
  }

  const userType = store.getters["auth/authUser"]?.type;

  if (to.name === "SignIn" && store.getters["auth/isAuthenticated"]) {
    return next("/");
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters["auth/isAuthenticated"]) {
      return next("/signIn");
    } else if (to.meta.role && !to.meta.role.includes(userType)) {
      return next("/");
    }
  }

  next();
});

export default router;
